/**
 * Tenant copy for cpcore's DISBURSEMENT_DATE_PASSED refusal (esign.service.ts
 * `disbursementDatePassedRefusal`): the journey's disbursement date is already behind us, so
 * e-sign stays stopped until the date is moved. Shown on the e-sign screen when the tenant taps
 * Next (src/components/banking/esign/index.jsx), never as a pop-up.
 *
 * Tenants don't know what a disbursement date is, so the copy talks about the move-in date, which
 * a partner tenant's disbursement date is set to. It sends the tenant to their own partner's
 * team; a partner not listed gets our support team.
 */
export const DISBURSEMENT_DATE_PASSED = "DISBURSEMENT_DATE_PASSED";

/** Partner tag → the name tenants know, spelled as the app's other tenant copy spells it. */
const PARTNER_TEAM_NAMES = Object.freeze({
  housr: "Housr",
  kots: "KOTS",
  truliv: "Truliv",
  meridianstays: "Meridian Stays",
  youthville: "Youthville",
  urbanroomz: "Urban Roomz",
  flent: "Flent",
});

export function disbursementDatePassedMessage(partner) {
  const tag = typeof partner === "string" ? partner.trim().toLowerCase() : "";
  const name = Object.prototype.hasOwnProperty.call(PARTNER_TEAM_NAMES, tag)
    ? PARTNER_TEAM_NAMES[tag]
    : null;
  const team = name ? `the ${name} team` : "our support team";
  return `Oops, the move-in date is incorrect. Please contact ${team} to continue.`;
}
